import type { IStarRatingIcon } from './helpers';

export const StarRatingIcon = ({ variant, ...rest }: IStarRatingIcon) =>
	variant === 'filled' ? (
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<path
				d='M7.51564 0.0306794L9.78572 4.64063L14.8712 5.38892L11.1875 8.97005L12.0513 14.035L7.50464 11.6385L2.95348 14.0263L3.82684 8.96302L0.149899 5.37486L5.23683 4.63629L7.51564 0.0306794Z'
				fill='#F59E0C'
			/>
		</svg>
	) : (
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<path
				d='M8.14998 0.938638L10.4201 5.54859L15.5056 6.29687L11.8218 9.87801L12.6856 14.943L8.13898 12.5464L3.58782 14.9343L4.46118 9.87098L0.784237 6.28282L5.87116 5.54425L8.14998 0.938638Z'
				stroke='#022745'
				strokeWidth='0.846087'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
